import { render, staticRenderFns } from "./HouseInfo.vue?vue&type=template&id=20375e5b&scoped=true&"
import script from "./HouseInfo.vue?vue&type=script&lang=js&"
export * from "./HouseInfo.vue?vue&type=script&lang=js&"
import style0 from "./HouseInfo.vue?vue&type=style&index=0&id=20375e5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20375e5b",
  null
  
)

export default component.exports